/**
 * Libraries
 */

import { createI18n } from 'vue-i18n';

/**
 * I18n
 */

import en from '@shared/i18n/en';
import fr from '@shared/i18n/fr';

/**
 * Types
 */

import { Locales, type MessageSchema } from '@shared/i18n/types';

const messages: Record<Locales, MessageSchema> = {
  [Locales.EN]: en,
  [Locales.FR]: fr,
};

function getNavigatorLocale() {
  const language = navigator.language.toLowerCase();
  const locales = Object.keys(messages);
  for (const locale of locales) {
    if (language.indexOf(locale) > -1) {
      return locale;
    }
  }
  return null;
}

const i18n = createI18n<[MessageSchema], Locales.FR | Locales.EN>({
  locale:
    getNavigatorLocale() || Locales[import.meta.env.VITE_APP_DEFAULT_LOCALE],
  fallbackLocale: Locales['FR'],
  // Must be set to 'false', to use Composition API
  legacy: false,
  globalInjection: true,
  messages,
  numberFormats: {
    fr: {
      decimal: {
        style: 'decimal',
      },
    },
    en: {
      decimal: {
        style: 'decimal',
      },
    },
  },
});

export default i18n;
